<template>
	<div class="topheader bg-white px-3 py-2 d-flex align-items-center justify-content-between">
		<div class="headerLogo">
			<img width="60" src="../../../../static/website/images/logo.svg" alt="Logo">
		</div>
		<div class="rightLinks d-flex align-items-center">
			<router-link to="/get-started" title="Go to Home">
	        	<feather type="home"></feather>
			</router-link>
	        <router-link title="Back" :to="($route.name == 'step_two')?'step1':($route.name == 'step_three')?'step2':''" v-if="$route.name == 'step_two' || $route.name == 'step_three'">
	        	<feather type="skip-back"></feather>
	        </router-link>
	    </div>
    </div>
</template>
<script>
	export default {
		name: 'step-header',
	}
</script>


// WEBPACK FOOTER //
// src/components/website/registerSteps/reg-step-header.vue